import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import type { InternalChatRespostaRapida } from '../../types';
import {
  createRespostaRapida,
  deleteRespostaRapida,
  fetchRespostasRapidas,
  updateRespostaRapida,
} from './actions';

interface RespostasRapidasState {
  items: InternalChatRespostaRapida[];
  isLoading: boolean;
  error: string | null;
  fetchedOnce: boolean;
  isMutating: boolean;
  mutationError: string | null;
}

const initialState: RespostasRapidasState = {
  items: [],
  isLoading: false,
  error: null,
  fetchedOnce: false,
  isMutating: false,
  mutationError: null,
};

const respostasRapidasSlice = createSlice({
  name: 'chatAtendimentoRespostasRapidas',
  initialState,
  reducers: {
    clearMutationError(state) {
      state.mutationError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRespostasRapidas.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRespostasRapidas.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload;
        state.fetchedOnce = true;
      })
      .addCase(fetchRespostasRapidas.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload ?? 'Erro ao carregar respostas rápidas';
      })
      .addCase(createRespostaRapida.fulfilled, (state, action) => {
        state.items = [...state.items, action.payload].sort((a, b) =>
          a.atalho.localeCompare(b.atalho),
        );
      })
      .addCase(updateRespostaRapida.fulfilled, (state, action) => {
        const idx = state.items.findIndex((i) => i.id === action.payload.id);
        if (idx >= 0) state.items[idx] = action.payload;
      })
      .addCase(deleteRespostaRapida.fulfilled, (state, action) => {
        state.items = state.items.filter((i) => i.id !== action.payload);
      })
      .addMatcher(
        isAnyOf(
          createRespostaRapida.pending,
          updateRespostaRapida.pending,
          deleteRespostaRapida.pending,
        ),
        (state) => {
          state.isMutating = true;
          state.mutationError = null;
        },
      )
      .addMatcher(
        isAnyOf(
          createRespostaRapida.fulfilled,
          updateRespostaRapida.fulfilled,
          deleteRespostaRapida.fulfilled,
        ),
        (state) => {
          state.isMutating = false;
        },
      )
      .addMatcher(
        isAnyOf(
          createRespostaRapida.rejected,
          updateRespostaRapida.rejected,
          deleteRespostaRapida.rejected,
        ),
        (state, action) => {
          state.isMutating = false;
          state.mutationError = action.payload ?? 'Erro ao salvar resposta rápida';
        },
      );
  },
});

export const { clearMutationError } = respostasRapidasSlice.actions;
export const respostasRapidasReducer = respostasRapidasSlice.reducer;
export type { RespostasRapidasState };
